import { faker } from '@faker-js/faker'
import { GetInvoiceBillsResponseBody, InvoiceBill } from '../types'
import { getCommodities } from './getCommodities'

export const generateInvoiceBillsResponse: (
    limit: number,
    totalItems: number
) => GetInvoiceBillsResponseBody = (limit, totalItems) => {
    const items = Array.from(new Array(limit)).map(() => {
        const invoiceBill: InvoiceBill = {
            billId: faker.number.int(),
            usn: faker.number.int({ min: 10000, max: 100000 }).toString(),
            usnAccountName: faker.lorem.words(2),
            meters: Array.from({
                length: faker.number.int({ min: 1, max: 6 }),
            }).map(() => ({
                meterId: faker.number.int(),
                meterName: faker.string.uuid(),
                meterNumber: faker.number
                    .int({ min: 1000, max: 10000 })
                    .toString(),
                facilityName: faker.lorem.words(2),
                facilityAddress: {
                    address1: faker.lorem.words(6),
                },
            })),
            startDate: faker.date.past().toISOString(),
            endDate: faker.date.recent().toISOString(),
            commodity: faker.helpers.arrayElement(getCommodities()),
            usage: {
                value: faker.number.float({ min: 100, max: 1000 }),
                unit: 'kWh',
            },
            amount: {
                value: faker.number.float({ min: 50, max: 500 }),
                unit: 'USD',
            },
            notesCount: faker.number.int({ min: 0, max: 20 }),
        }

        return invoiceBill
    })

    return {
        items,
        totalItems,
    }
}
